module.exports = __webpack_public_path__ + "img/leap-logo-180x70.25078780.png";